import { FC } from "react";


import { ServicesBuildingOrgsPageId } from "utils/useScroll";
import { Box } from "@chakra-ui/react";
import ServiceDescriptor from "./ServiceDescriptor";
import NextStepsSection from "./NextSteps";
import DeliverablesSection from "./Deliverables";
import { RiOrganizationChart } from "react-icons/ri";
import { RiTableAltFill } from "react-icons/ri";
import { TbBoxModel2Off } from "react-icons/tb";


import { FaChartLine, FaMap, FaClipboardList, FaTools } from "react-icons/fa";

export const BuildingOrgService: FC = () => {

 const label =  "Technical Advice";
  const title = "Scalable Growth Strategy & Organizational Design";
  const footer = "";
  const services = [
    {
      title: "Organizational Architecture",
      icon: RiOrganizationChart,
      items: [
        "Structure Optimization: Design teams for autonomy-alignment balance (Spotify squad model vs. traditional matrix adaptations)",
        "Decision Rights Mapping: Clarify what decisions should be centralized vs. distributed",
        "Span of Control Analysis: Optimize management layers and reporting structures",
        "Growth Readiness Assessment: Stress-test your org design against 2x/5x headcount scenarios"]
        
    },
    {
      title: "Engagement Models and Operations",
      icon: TbBoxModel2Off,
      items: [
        "Meeting rhythms that actually save time (Amazon-style memo culture vs. agile standups)",
        "Lightweight OKR/PI planning systems that drive focus",
        "Cross-functional collaboration patterns that prevent silos",
        "Values translation into observable behaviors",
        "Promotion/compensation frameworks that reinforce priorities",
        "Remote/hybrid rituals that maintain cohesion"
      ]
    },
    {
      title: "Capability Building",
      icon: RiTableAltFill,
      items: [
        "Build vs. buy vs. rent analysis for critical roles",
        "Competency mapping for future-state needs",
        "Leadership pipeline development",
        "Tech stack evaluation against scaling needs",
        "Automation opportunity identification"
      ]
    }
    
  ];
  return (
    <Box id={ServicesBuildingOrgsPageId}>
      <ServiceDescriptor title={title} label={label} footer={footer} services={services} prevRoute="/techadvice" nextRoute="/workshops" />

      <DeliverablesSection deliverables={[
          {
            icon: FaChartLine,
            title: "Org Health Dashboard",
            description: "12-15 key indicators of scaling readiness",
            tags: ["Metrics", "Visualization"]
          },
          {
            icon: FaMap,
            title: "Structure Options Paper",
            description: "2-3 validated design alternatives with tradeoffs",
            tags: ["Analysis", "Recommendations"]
          },
          {
            icon: FaClipboardList,
            title: "Transition Roadmap",
            description: "30/60/90 day action plans with ownership",
            tags: ["Planning", "Execution"]
          },
          {
            icon: FaTools,
            title: "Playbook Templates",
            description: "Meeting, planning, and decision artifacts",
            tags: ["Templates", "Tools"]
          }
        ]} />
      <NextStepsSection title="Ready to Scale Your Organization and Overcome Future Challanges?" 
      message="Take the next step toward an organization that scales and thrive" 
      actionHeading="Schedule Consultation" 
      actionText="Book a 90-minute discovery session to discuss your specific organizational challenges" 
      actionLabel="Contact Me and Book Today"/>
    </Box>

  );

}
export default BuildingOrgService;
